import React, { Fragment, useEffect } from "react";
import logo from "../../../assets/images/logo.png";
import {
  Navbar,
  NavbarBrand,
  Container,
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Button,
  Badge,
} from "reactstrap";
import { AGENCY_DOCUMENT_DETAILS_URL } from "../../../utils/APIEndpoints";
import {
  authHeader,
  loggedUserDetails,
} from "../../../utils/functions/CoreFunctions";
import API from "../../../redux/actions/API";
import { useState } from "react";
import STEP_TWO_BUILD_DOCUMENT from "../createDocument/STEP_TWO_BUILD_DOCUMENT";
import { Link, useHistory } from "react-router-dom";
import CustomPageNotFound from "../../common/CustomPageNotFound";

function ViewDocument(props) {
  const {
    match: {
      params: { id: agencyServiceId = "" },
    },
  } = props;

  //State
  const [documentDetails, setDocumentDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const { agencyId: loggedAgency = "", role: loggedUserRole = "" } =
    loggedUserDetails();

  //Get Document Details
  const getDocumentDetails = async () => {
    try {
      setLoading(true);
      const options = {
        method: "GET",
        url: AGENCY_DOCUMENT_DETAILS_URL,
        headers: authHeader(),
        params: { agencyServiceId: parseInt(agencyServiceId) },
      };
      const response = await API(options);
      let apiResponse = response.data;
      const { status } = apiResponse;
      if (status === "Success") {
        setDocumentDetails(apiResponse.data);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        // Swal.fire(getAlert('error',data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  //Did Mount
  useEffect(() => {
    if (agencyServiceId) {
      getDocumentDetails();
    }
  }, [agencyServiceId]);

  const {
    agencyId = "",
    templatePlaceHolderValue = "",
    requiredDocuments = "",
    serviceAmount = 0,
    serviceDescription = "",
    serviceDomainURL = "",
    serviceName = "",
    status: documentStatus = "",
  } = documentDetails;
  let cleaned = templatePlaceHolderValue
  ? templatePlaceHolderValue.replace(/\u0019/g, "'")
    : "[]";
    console.log('cleaned text 3');
  const documentsList = JSON.parse(cleaned || "[]");
  const additionalDocumentsList = JSON.parse(requiredDocuments || "[]");

  return (
    <Fragment>
      <Navbar fixed="top" color="light" light className="navbar-bg" expand="md">
        <NavbarBrand href="/">
          {" "}
          <img src={logo} />
        </NavbarBrand>
      </Navbar>
      <div>
        <Container>
          <Row>
            {loading ? (
              <Col md={12}>
                <center>
                  <div>
                    <p style={{ color: "#fff" }}>Loading...</p>
                  </div>
                </center>
              </Col>
            ) : (
              <Fragment>
                {loggedUserRole === "PayGov Admin" ||
                parseInt(loggedAgency) === parseInt(agencyId) ? (
                  <Fragment>
                    <Col md={8}>
                      <STEP_TWO_BUILD_DOCUMENT
                        isPreviewDocument={true}
                        documentsList={documentsList}
                      />
                    </Col>
                    <Col md={4}>
                      <Card>
                        <CardHeader>
                          {serviceName}
                          {documentStatus === "New" ? (
                            <Link to={`/edit-document/${agencyServiceId}`}>
                              <Button
                                className="action-btn"
                                color="info"
                                style={{ float: "right" }}
                              >
                                Edit
                              </Button>
                            </Link>
                          ) : (
                            <Badge
                              color="secondary"
                              style={{ color: "#fff", float: "right" }}
                            >
                              {documentStatus}
                            </Badge>
                          )}
                        </CardHeader>
                        <CardBody>
                          <p>
                            Description :<b> {serviceDescription}</b>
                          </p>
                          <p>
                            Hyperlink :<b> {serviceDomainURL}</b>
                          </p>
                          <p>
                            Fee :<b> ${parseFloat(serviceAmount).toFixed(2)}</b>
                          </p>
                          {additionalDocumentsList &&
                          additionalDocumentsList.length ? (
                            <Fragment>
                              <CardTitle>Additional Documents</CardTitle>
                              <Table responsive bordered>
                                <thead>
                                  <tr>
                                    <th>Document Name</th>
                                    <th>Description</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {additionalDocumentsList.map(
                                    ({ documentName, description }, index) => (
                                      <tr key={`add_list_${index}`}>
                                        <td>{documentName || "-"}</td>
                                        <td>{description || "-"}</td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </Table>
                            </Fragment>
                          ) : (
                            <CardTitle>
                              No additional documents are needed!
                            </CardTitle>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Fragment>
                ) : (
                  <Col md={12}>
                    <CustomPageNotFound />
                  </Col>
                )}
              </Fragment>
            )}
          </Row>
        </Container>
      </div>
    </Fragment>
  );
}
export default ViewDocument;
